import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { breakDataTags } from '../../../utils/breakDataTags'
import { TestingLab } from '../TestingLabsContext'

export function useExpand(): ExpandOptions<TestingLab> {
  return {
    expandable: ({ concreteCoreBreakDatas, concreteTestBreakDatas }) =>
      !!concreteCoreBreakDatas.length || !!concreteTestBreakDatas.length,
    render: (testingLab) => ({
      additionalInfo: [breakDataTags(testingLab)],
    }),
  }
}
